/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type FeedbackOrderStatusQueryVariables = Types.Exact<{
  orderId: Types.Scalars['ID']['input'];
}>;

export type FeedbackOrderStatusQuery = {
  readonly __typename?: 'Query';
  readonly orderStatus:
    | { readonly __typename: 'InvalidOrder' }
    | {
        readonly __typename: 'OrderStatus';
        readonly flattenedOrderStatus: Types.FlattenedOrderStatuses;
        readonly order: {
          readonly __typename: 'Order';
          readonly id: string;
          readonly orderType: Types.OrderType;
          readonly wantedTime: string;
          readonly description: string;
          readonly isPendingFeedback: boolean;
          readonly restaurant: {
            readonly __typename: 'Restaurant';
            readonly id: string;
            readonly entityId: number | null;
            readonly slug: string;
            readonly name: string;
            readonly isOutpost: boolean;
          };
          readonly lineItems: ReadonlyArray<{
            readonly __typename: 'LineItem';
            readonly id: string;
            readonly quantity: number;
            readonly customName: string | null;
            readonly product: {
              readonly __typename: 'Product';
              readonly id: string;
              readonly name: string;
              readonly slug: string;
            };
          }>;
          readonly deliveryOrderDetail: {
            readonly __typename: 'DeliveryOrderDetail';
            readonly id: string;
            readonly estimatedDeliveryTime: string | null;
          } | null;
        };
      }
    | null;
};

export type FeedbackInStoreOrderStatusQueryVariables = Types.Exact<{
  orderId: Types.Scalars['ID']['input'];
}>;

export type FeedbackInStoreOrderStatusQuery = {
  readonly __typename?: 'Query';
  readonly inStoreLoyaltyOrder: {
    readonly __typename: 'InStoreOrder';
    readonly id: string;
    readonly wantedTime: string;
    readonly isPendingFeedback: boolean;
    readonly restaurant: {
      readonly __typename: 'InStoreOrderRestaurant';
      readonly entityId: string;
    };
  } | null;
};

export type SaveFeedbackCaseMutationVariables = Types.Exact<{
  input: Types.SaveFeedbackCaseInput;
}>;

export type SaveFeedbackCaseMutation = {
  readonly __typename?: 'Mutation';
  readonly saveFeedbackCase: { readonly __typename: 'FeedbackSuccess'; readonly success: boolean };
};

export const FeedbackOrderStatusDocument = gql`
  query feedbackOrderStatus($orderId: ID!) {
    orderStatus(orderId: $orderId) {
      __typename
      ... on OrderStatus {
        flattenedOrderStatus
        order {
          id
          __typename
          orderType
          wantedTime
          description
          isPendingFeedback
          restaurant {
            id
            __typename
            entityId
            slug
            name
            isOutpost
          }
          lineItems {
            id
            __typename
            quantity
            customName
            product {
              id
              __typename
              name
              slug
            }
          }
          deliveryOrderDetail {
            id
            __typename
            estimatedDeliveryTime
          }
        }
      }
    }
  }
`;

export function useFeedbackOrderStatusQuery(
  options: Omit<Urql.UseQueryArgs<FeedbackOrderStatusQueryVariables>, 'query'>,
) {
  return Urql.useQuery<FeedbackOrderStatusQuery, FeedbackOrderStatusQueryVariables>({
    query: FeedbackOrderStatusDocument,
    ...options,
  });
}
export const FeedbackInStoreOrderStatusDocument = gql`
  query feedbackInStoreOrderStatus($orderId: ID!) {
    inStoreLoyaltyOrder(input: { id: $orderId }) {
      __typename
      id
      wantedTime
      isPendingFeedback
      restaurant {
        __typename
        entityId
      }
    }
  }
`;

export function useFeedbackInStoreOrderStatusQuery(
  options: Omit<Urql.UseQueryArgs<FeedbackInStoreOrderStatusQueryVariables>, 'query'>,
) {
  return Urql.useQuery<FeedbackInStoreOrderStatusQuery, FeedbackInStoreOrderStatusQueryVariables>({
    query: FeedbackInStoreOrderStatusDocument,
    ...options,
  });
}
export const SaveFeedbackCaseDocument = gql`
  mutation saveFeedbackCase($input: SaveFeedbackCaseInput!) {
    saveFeedbackCase(input: $input) {
      __typename
      success
    }
  }
`;

export function useSaveFeedbackCaseMutation() {
  return Urql.useMutation<SaveFeedbackCaseMutation, SaveFeedbackCaseMutationVariables>(
    SaveFeedbackCaseDocument,
  );
}
